export function decomposeHex(hex) {
  if (hex == null) return [255, 255, 255];

  if (hex.length == 7) hex = hex.substring(1);
  var R = parseInt(hex.substring(0, 2), 16);
  var G = parseInt(hex.substring(2, 4), 16);
  var B = parseInt(hex.substring(4, 6), 16);
  return [R, G, B];
}
